export default __webpack_public_path__ + "static/media/mj_profile.e8e51a9b.jpeg";